const localStoragePrefix = 'storeeel_campaign_click';

export const campaignClickRepository = {
  set(campaignId) {
    const expireAt = Date.now() + 24 * 60 * 60 * 1000; // 24時間後

    const existing = JSON.parse(localStorage.getItem(localStoragePrefix) || "{}");

    existing[campaignId] = { TTL: expireAt };

    localStorage.setItem(localStoragePrefix, JSON.stringify(existing));
  },

  getAllValid() {
    const now = Date.now();
    const result = {};

    try {
      const data = JSON.parse(localStorage.getItem(localStoragePrefix) || '{}');

      Object.entries(data).forEach(([campaignId, info]) => {
        if (info.TTL > now) {
          result[campaignId] = info;
        }
      });

      return result;
    } catch {
      return {};
    }
  },
  removeExpiredCampaigns() {
    const data = JSON.parse(localStorage.getItem(localStoragePrefix) || "{}");
    const now = Date.now();
    let updated = false;

    Object.entries(data).forEach(([campaignId, info]) => {
      if (info.TTL <= now) {
        delete data[campaignId];
        updated = true;
      }
    });

    if (updated) {
      localStorage.setItem(localStoragePrefix, JSON.stringify(data));
    }
  },
  remove(campaignId) {
    const data = JSON.parse(localStorage.getItem(localStoragePrefix) || "{}");

    if (campaignId in data) {
      delete data[campaignId];
      localStorage.setItem(localStoragePrefix, JSON.stringify(data));
    }
  }
};
